import InputError from "./InputError";

const Input = ({
  type = "text",
  isEnabled = true,
  name,
  value,
  error,
  ...props
}) => {
  return (
    <>
      <label htmlFor={name} className="input__label">
        <input
          className="input"
          type={type}
          name={name}
          id={name}
          value={value}
          disabled={!isEnabled}
          {...props}
        />
        <InputError error={error} />
      </label>
    </>
  );
};

export default Input;
